






















import { FinanceType, LoadingStatusType } from "@/enums/enums";
import { RemoveTextInDescription, SuggestionDescription } from "@/helper/transactionItemHelper";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreProduct = namespace("Product");

@Component
export default class DropdownProductId extends Vue {
  @Prop({}) readonly index!: number;
  @Prop({}) readonly transactionItem!: any;
  @Prop({}) readonly transactionCreate!: any;
  @Prop({}) readonly financeType!: FinanceType;

  private productList: any = [];
  private selectProduct: any = "";

  @StoreProduct.Getter
  private getAllProductTemplateList!: any;
  @StoreProduct.Getter
  private getProductTemplateListLoadingStatus!: any;

  @StoreProduct.Action
  private DoGetAllProductTemplate!: () => void;

  get isProductListLoading() {
    return this.getProductTemplateListLoadingStatus == LoadingStatusType.Loading;
  }

  @Watch("transactionItem.productTemplate.id")
  transactionProductIdChanged() {
    if (this.getProductTemplateListLoadingStatus === LoadingStatusType.Success) {
      this.DoMatchProductTemplate();
    }
  }

  @Watch("transactionItem.productTemplate.code")
  transactionProductCodeChanged() {
    if (this.getProductTemplateListLoadingStatus === LoadingStatusType.Success) {
      this.DoMatchProductTemplate();
    }
  }

  @Watch("getProductTemplateListLoadingStatus", { immediate: true })
  getProductTemplateListLoadingStatusChanged() {
    if (this.getProductTemplateListLoadingStatus == LoadingStatusType.Success) {
      this.productList = [];
      if (this.getAllProductTemplateList.length > 0) {
        this.getAllProductTemplateList.forEach((product: any) => {
          if (!product.isArchived && !product.isDeleted) {
            this.productList.push(product);
          }
        });
      }
      if (typeof this.transactionItem !== "undefined") {
        this.DoMatchProductTemplate();
      }
    } else if (this.getProductTemplateListLoadingStatus == LoadingStatusType.None) {
      this.DoGetAllProductTemplate();
    }
  }

  @Watch("selectProduct")
  selectProductChanged(newVal: any, oldVal: any) {
    if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
      this.SelectProduct(this.selectProduct);
    }
  }

  public SetProductIsNotAuto() {
    this.transactionItem.productTemplate.isNotAuto = false;
  }

  public SelectProduct(item: any) {
    if (item) {
      this.selectProduct = item;
      this.OnChangeProduct(item);
    } else {
      this.SetDefaultProduct();
    }
  }

  public OnChangeProduct(item: any) {
    const oldDescription =
      this.transactionItem.productTemplate.name +
      (this.transactionItem.productTemplate.description
        ? " : " + this.transactionItem.productTemplate.description
        : "");

    const newDescription = item.name + (item.description ? " : " + item.description : "");

    if (this.transactionItem.vatTypeId.isSuggestion) {
      if (this.financeType === FinanceType.OutFlow) {
        this.transactionItem.vatTypeId.value = item.purchaseVatType;
      } else {
        this.transactionItem.vatTypeId.value = item.sellVatType;
      }
      this.transactionItem.vatTypeId.isSuggestion = false;
    }
    if (!this.transactionItem.productTemplate.isNotAuto) {
      this.transactionItem.account.isNotAuto = true;
      if (this.financeType === FinanceType.OutFlow) {
        this.transactionItem.account.id = item.purchaseAccountId;
        this.transactionItem.vatTypeId.value = item.purchaseVatType;
        this.transactionItem.price.value = item.purchasePrice.FormatMoney();
      } else {
        this.transactionItem.account.id = item.sellAccountId;
        this.transactionItem.vatTypeId.value = item.sellVatType;
        this.transactionItem.price.value = item.sellPrice.FormatMoney();
      }

      this.transactionItem.description.text = RemoveTextInDescription(
        this.transactionItem.account.name,
        this.transactionItem.description.text
      );

      this.transactionItem.description.text = SuggestionDescription(
        newDescription,
        oldDescription,
        this.transactionItem.description.text
      );
    } else if (!this.transactionItem.account.isNotAuto) {
      this.transactionItem.account.isNotAuto = true;
      if (this.financeType === FinanceType.OutFlow) {
        this.transactionItem.account.id = item.purchaseAccountId;
      } else {
        this.transactionItem.account.id = item.sellAccountId;
      }
      if (this.transactionItem.description.text == null || this.transactionItem.description.text === "") {
        this.transactionItem.description.text = SuggestionDescription(
          newDescription,
          oldDescription,
          this.transactionItem.description.text
        );
      }
    } else {
      if (this.transactionItem.description.text == null || this.transactionItem.description.text === "") {
        this.transactionItem.description.text = SuggestionDescription(
          newDescription,
          oldDescription,
          this.transactionItem.description.text
        );
      }
      if (
        this.transactionItem.account.id == 0 &&
        (this.transactionItem.account.code == null || this.transactionItem.account.code === "")
      ) {
        if (this.financeType === FinanceType.OutFlow) {
          this.transactionItem.account.id = item.purchaseAccountId;
        } else {
          this.transactionItem.account.id = item.sellAccountId;
        }
      }
    }

    this.transactionItem.productTemplate.code = item.code;
    this.transactionItem.productTemplate.id = item.id;
    this.transactionItem.productTemplate.name = item.name;
    this.transactionItem.productTemplate.description = item.description;
    this.transactionItem.productTemplate.productTypeId = item.typeId;

    this.$emit("change");
  }

  public SetDefaultProduct() {
    this.transactionItem.productTemplate.code = "";
    this.transactionItem.productTemplate.id = 0;
    this.$emit("change");
  }

  public DoMatchProductTemplate() {
    this.$nextTick(() => {
      if (this.transactionItem.productTemplate.id > 0) {
        this.selectProduct = this.getAllProductTemplateList.find(
          (x: any) => x.id === this.transactionItem.productTemplate.id
        );
      } else if (this.transactionItem.productTemplate.code && this.transactionItem.productTemplate.code.length !== 0) {
        this.selectProduct = this.getAllProductTemplateList.find(
          (x: any) => x.code === this.transactionItem.productTemplate.code
        );
      } else {
        this.selectProduct = "";
      }
    });
  }
}
